import { useEffect } from 'react';
import { replayAll } from './queue';

/**
 * Subscribe to the browser's `online` event and trigger `replayAll`
 * once. Mounted at the AppShell level so it runs across the whole
 * authenticated UI without per-page wiring.
 *
 * We don't run on mount: the SW handles a cold-start cache, and the
 * mutations queue is drained either when the user comes back online
 * or via a manual replay button (F11.4).
 */
export function useReplayOnReconnect(): void {
  useEffect(() => {
    const handleOnline = () => {
      void replayAll().catch(() => {
        // Errors are stored on individual rows by replayOne — there
        // is no global notification surface here. The badge picks up
        // the result through useLiveQuery.
      });
    };
    window.addEventListener('online', handleOnline);
    return () => window.removeEventListener('online', handleOnline);
  }, []);
}
